import { render, staticRenderFns } from "./AutoEvaluation.vue?vue&type=template&id=606ded1d&"
import script from "./AutoEvaluation.vue?vue&type=script&lang=js&"
export * from "./AutoEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports